import template from './opportunityFundingCalculator.html';
import './style.scss';

export default {
  template,
  controllerAs: 'vm',
  bindings: {
    opportunityCalculationService: '<',
  },
};
